import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "../../../node_modules/axios/index";
import { toast } from "react-toastify";
import { getNotificationList } from "../../redux/actions/notificationAction/NotificationAction";
import { setInValidUser } from "../../redux/actions/authActions/authAction";
import allNotificationIcon from "../../assets/images/all-notifications.png";
import { handleApiError } from "../../helpers/errorResponseHelper";

const NotificationFilterDropDown = (props) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const organizationId = userData?.organizationId;

  const accessToken = localStorage?.getItem("accessToken");
  const dispatch = useDispatch();
  const filterNotification = async (payload) => {
    try {
      if (accessToken) {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/V1/notification/viewNotifications`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: accessToken,
            },
          }
        );
        if (response?.data?.data?.isInValidUser) {
          dispatch(setInValidUser(true));
        } else {
          dispatch(setInValidUser(false));
        }
        if (response.data.success) {
          dispatch(getNotificationList(response.data));
          toast.success(response.data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } else {
          toast.error(response.data.message, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      }
    } catch (error) {
      if (handleApiError(error)) return;
    }
  };

  return (
    <>
      <Dropdown className="border-radius0">
        <Dropdown.Toggle className="btn add-btn Mom-btn d-flex align-items-center justify-content-center border-radius0 filter-height">
          <p> Filter</p>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            className="bi-funnel filter-svg"
            viewBox="0 0 16 16"
          >
            <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z" />
          </svg>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Link
            style={{
              textDecoration: "none",
              color: "black",
            }}
          >
            <Dropdown.Item
              href="#/action-2"
              onClick={() => filterNotification({ organizationId })}
            >
              <img
                src={allNotificationIcon}
                alt="All Notification"
                className="all-notification-icon"
              />
              All
            </Dropdown.Item>
          </Link>

          <Link
            style={{
              textDecoration: "none",
              color: "black",
            }}
          >
            <Dropdown.Item
              href="#/action-2"
              onClick={() =>
                filterNotification({ organizationId, isRead: true })
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="19"
                height="19"
                fill="currentColor"
                className="bi bi-bookmark-check me-2"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0"
                />
                <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z" />
              </svg>
              Read
            </Dropdown.Item>
          </Link>

          <Link
            style={{
              textDecoration: "none",
              color: "black",
            }}
          >
            <Dropdown.Item
              href="#/action-2"
              onClick={() =>
                filterNotification({ organizationId, isRead: false })
              }
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-bookmark-x me-2"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M6.146 5.146a.5.5 0 0 1 .708 0L8 6.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 7l1.147 1.146a.5.5 0 0 1-.708.708L8 7.707 6.854 8.854a.5.5 0 1 1-.708-.708L7.293 7 6.146 5.854a.5.5 0 0 1 0-.708"
                />
                <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v13.5a.5.5 0 0 1-.777.416L8 13.101l-5.223 2.815A.5.5 0 0 1 2 15.5zm2-1a1 1 0 0 0-1 1v12.566l4.723-2.482a.5.5 0 0 1 .554 0L13 14.566V2a1 1 0 0 0-1-1z" />
              </svg>
              Unread
            </Dropdown.Item>
          </Link>

          <Link
            onClick={() =>
              filterNotification({ organizationId, isImportant: true })
            }
            style={{
              textDecoration: "none",
              color: "black",
            }}
          >
            <Dropdown.Item href="#/action-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                fill="currentColor"
                className="bi bi-star me-2"
                viewBox="0 0 16 16"
              >
                <path d="M2.866 14.85c-.078.444.36.791.746.593l4.39-2.256 4.389 2.256c.386.198.824-.149.746-.592l-.83-4.73 3.522-3.356c.33-.314.16-.888-.282-.95l-4.898-.696L8.465.792a.513.513 0 0 0-.927 0L5.354 5.12l-4.898.696c-.441.062-.612.636-.283.95l3.523 3.356-.83 4.73zm4.905-2.767-3.686 1.894.694-3.957a.56.56 0 0 0-.163-.505L1.71 6.745l4.052-.576a.53.53 0 0 0 .393-.288L8 2.223l1.847 3.658a.53.53 0 0 0 .393.288l4.052.575-2.906 2.77a.56.56 0 0 0-.163.506l.694 3.957-3.686-1.894a.5.5 0 0 0-.461 0z" />
              </svg>
              Important
            </Dropdown.Item>
          </Link>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default NotificationFilterDropDown;
